module.exports = __webpack_public_path__ + "static/media/PHP.2c4b133a.svg";